var app = require('../index'),
	deepCopy = require('../../util/deepCopy'),
	Subscription = require('../../data-objects/Subscription'),
	moment = require('moment'),
	rsvp = require('rsvp');
//polyfills for the Date object
require('date-utils');

module.exports = usageRoute;

app.get('/usage', usageRoute);
app.get('/usage/:id', usageRoute);

//Note: This could be a server-side route since it queries MongoDB directly.
//It was only created as a Derby route for ease of development.
//(Getting the app instance via page._res.req.app is a hack.)

function usageRoute(page, model, params, next /*, isAdmin */) {
	//always render on server
	if (!require('derby').util.isServer) return next();
	
	//temp solution since we're currently just redirecting to this page
	//for the admin version of this
	var isAdmin = model.get('_session.user.isAdmin');
	model.set('_page.isAdmin', isAdmin);
	
	var subId;
	if (params.id) {
		//only admins can look up stats for any subscription
		if (!isAdmin) {
			return next('_session.subscriptionId is empty and user is not an admin');
		}
		subId = params.id;
	}
	else {
		subId = model.get('_session.subscriptionId');
	}
	
	//var subId = model.get('_session.subscriptionId') || params.id;
	model.set('_page.subId', subId);
	
	var statType = params.query.statType || 'logins';
	model.set('_page.statType', statType);
	
	//The name of the field containing the date/time of the login or search
	var timeFieldName = (statType == 'logins' ? 'loginTime': 'timestamp');
	
	var app = page._res.req.app;
	var db = app.locals.store.shareClient.backend.snapshotDb.mongo;
	
	var now = new Date();
	var startMonth = params.query.startMonth;
	var startYear = params.query.startYear;
	if (!(startMonth && startYear)) {
		//default to showing 1 year prior to this month
		startMonth = now.getMonth() + 1;
		startYear = now.getFullYear() - 1;
	}
	
	model.set('_page.startMonth', startMonth.toString());
	model.set('_page.startYear', startYear.toString());
	
	var minDate = new Date(startMonth + '/1/' + startYear);
	
	var subscriptionModel = model.at('subscriptions.' + subId);
	var sub,
		subIds;
	subscriptionModel.fetchGet().then(function(subscription) {
		sub = Subscription.fromJSON( deepCopy(subscription) );
		model.set('_page.subscription', sub);
		model.set('_page.institutionName', sub.institutionName || '[Missing Institution Name]');
	})
	.then(function getPastSubs() {
		//get up to 4 previous subscriptions
		maxPastSubs = 4;
		if (!sub.institutionDomainName) {
			console.error("Missing domain name for subscription ID '" + subId + "'");
			return [];
		}
		
		var query = model.query('subscriptions', {
			id: {$ne: sub.id},
			institutionDomainName: sub.institutionDomainName,
			$orderby: {startDate:1},
			$limit: maxPastSubs
		});
		return query.fetchGet();
	})
	.then(function(pastSubs) {
		//get the earliest start date of the subscriptions found
		//and get IDs of each subscription
		var minSubStartDate = new Date(sub.startDate);
		var subIds = pastSubs.map(function(s) {
			var startDate = new Date(s.startDate);
			if (startDate < minSubStartDate) {
				minSubStartDate = startDate;
			}
			
			return s.id;
		});
		subIds.unshift(subId);
		
		//no point in reporting stats from before they exist
		if (statType == 'searches') {
			//date we began collecting stats on searches (actual date was end of May but starting in June is cleaner)
			var dateCollectionBegan = new Date('06/01/2016');
			if (minDate < dateCollectionBegan) {
				minDate = dateCollectionBegan;
			}
		}
		else if (minDate < minSubStartDate) {
			minDate = minSubStartDate;
		}
		
		var collName = (statType == 'logins' ? 'logins': 'searches');
		var coll = db.collection(collName);
		
		var queryParams = {subscriptionId: {$in: subIds}};
		queryParams[timeFieldName] = {$gt: minDate.getTime()};
		var orderBy = {id: 1};
		orderBy[timeFieldName] = 1;
		
		var result = coll.find(queryParams);
		result.toArray = rsvp.denodeify(result.toArray);
		return result.toArray();
	})
	.then(function(data) {
		//Avoid overloading the system with large datasets.
		//(50,000 records is an arbitrary limit; further testing could be done to determine a better limit.)
		//Also, if there are more than 50,000 logins for a particular subscription, it's probably because logins or searches are
		//being recorded erroneously, so this is a safeguard against that too.
		if (data.length > 50000) {
			model.set('_page.message', 'Error: The number of hits in the date range you selected exceeds 50,000, which is more than'
				+ ' this interface can process. Please contact us and we will provide statistics; we apologize for the inconvenience.');
			page.render('message');
			return;
		}
	
		reporStats(statType, data);
		
		//Populate options for month and year dropdowns
		
		var months = [];
		for (var i = 0; i < 12; i++) {
			months.push({
				num: (i+1).toString(),
				name: moment().month(i).format("MMMM")
			});
		}
		model.set('_page.months', months);
		
		var curYear = now.getFullYear();
		var years = [];
		for (var i = curYear; i > curYear - 4; i--) {
			years.push(i.toString());
		}
		model.set('_page.years', years);
		
		page.render('account:usage');
	})
	.catch(function(err) {
		next(err);
	});
	
	function reporStats(statType, data) {
		var hitsByMonth = {};
		//var hitsByYear = {};
		data.forEach(function(hit) {
			var t = new Date(hit[timeFieldName]),
				year = t.getFullYear(),
				monthAndYear = t.getMonth() + '/' + year;
			
			if (!hitsByMonth[monthAndYear]) hitsByMonth[monthAndYear] = [];
			hitsByMonth[monthAndYear].push(t);
			
			/*
			if (!(year in hitsByYear)) {
				hitsByYear[year] = 0;
			}
			hitsByYear[year]++;
			*/
		});
		
		var date = minDate,
			now = new Date();
				
		var monthlyTotals = [],
			totalInPeriod = 0;
		
		do {
			year = date.getFullYear();
			var monthAndYear = date.getMonth() + '/' + year;
			
			var numHits = (hitsByMonth[monthAndYear] ? hitsByMonth[monthAndYear].length: 0);
			totalInPeriod += numHits;
			
			monthlyTotals.push({
				monthName: date.toFormat('MMMM'),
				year: year,
				numHits: numHits
			});
			
			date.addMonths(1);
		}
		while (date < now);
		
		model.set('_page.monthlyTotals', monthlyTotals);
		model.set('_page.totalInPeriod', totalInPeriod);
	}
}